// Ordered highest to lowest. EXTERNAL ("Externista") is an outside collaborator
// — a subcontractor or a designer from another firm — who works on projects but
// holds nothing on the organisation plane.
export const RIGHTS = ['OWNER', 'ADMIN', 'USER', 'EXTERNAL']

export const RIGHTS_COLORS = {
  OWNER: 'danger',
  ADMIN: 'warning',
  USER: 'info',
  EXTERNAL: 'secondary',
}
